import { Subject } from 'rxjs';
import { SidenavContentConfig, SidenavContentService } from './sidenav-content.service';
import { ComponentRef } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

export class SidenavContentRef<T, R = any> {
    _componentRef: ComponentRef<any>;

    private _parentRef: {
        className: string;
        el: Element;
    } = null;

    private readonly _afterOpened = new Subject<void>();
    private readonly _afterClosed = new Subject<R | undefined>();
    private readonly _beforeClosed = new Subject<R | undefined>();

    constructor(
            public _sidenavInstance: MatSidenav,
            private _sidenavContentService: SidenavContentService,
            private _config?: SidenavContentConfig<any>,
    ) {
        this._sidenavInstance.open().then(() => {
            if (this._config?.initialLoadingState) {
                this.loading = true;
            }

            this._afterOpened.next();
            this._afterOpened.complete();
        });
    }

    set loading(isLoading: boolean) {
        this._sidenavContentService.loading = isLoading;
    }

    setParentClass(el: Element, className: string) {
        this._parentRef = { className, el };
        this._parentRef.el.classList.add(this._parentRef.className);
    }

    close(sidenavResult?: R): void {
        for (const key in sidenavResult) {
            if (sidenavResult.hasOwnProperty(key) && key.includes('switchTo')) {
                this._clearSidenav();
                this.loading = true;

                this._beforeClosed.next(sidenavResult);
                this._beforeClosed.complete();
                return;
            }
        }

        this._beforeClosed.next(sidenavResult);
        this._beforeClosed.complete();

        this._sidenavInstance.close().then(() => {
            this._clearSidenav();
            this.loading = false;

            this._afterClosed.next(sidenavResult);
            this._afterClosed.complete();
        });
    }

    afterOpened() {
        return this._afterOpened.asObservable();
    }

    afterClosed() {
        return this._afterClosed.asObservable();
    }

    beforeClosed() {
        return this._beforeClosed.asObservable();
    }

    private _clearSidenav() {
        if (this._parentRef) {
            this._parentRef.el.classList.remove(this._parentRef.className);
            this._parentRef = null;
        }

        this._sidenavContentService._title = null;
        this._sidenavContentService._actions = null;
        this._sidenavContentService.loading = false;
    }
}
